import React, { useCallback } from 'react'
import Counter, { CounterChangeEventHandler } from 'LuxKit/Counter'
import noop from 'lib/function/noop'

interface Props {
  quantity: number
  inventory?: number | null
  onAddItem?: () => void
  onRemoveItem?: () => void
}

function MerchandiseCartReviewTileQuantitySelector(props: Props) {
  const {
    quantity,
    inventory,
    onAddItem = noop,
    onRemoveItem = noop,
  } = props

  const handleQuantityChange = useCallback<CounterChangeEventHandler>((value, _, event) => {
    event.preventDefault()
    if (value > quantity) {
      onAddItem()
    } else {
      onRemoveItem()
    }
  }, [quantity, onAddItem, onRemoveItem])

  if (!inventory) {
    return null
  }

  return <Counter
    size="small"
    value={quantity}
    min={1}
    max={inventory}
    onChange={handleQuantityChange}
  />
}

export default React.memo(MerchandiseCartReviewTileQuantitySelector)
